import { FC } from 'react';

import { SEARCH_TEST_ID } from '../../../test/test-ids';
import { AutoCompleteSkeleton } from './AutoCompleteSkeleton';
import { ProductCardsSkeleton } from './ProductCardsSkeleton';
import { SkeletonGroupsWrapper } from './Skeletons.styles';

type Props = {
    isNavBar?: boolean;
};

export const AllSuggestionsSkeleton: FC<Props> = ({ isNavBar = false }) => {
    return (
        <SkeletonGroupsWrapper $isNavBar={isNavBar} data-test={SEARCH_TEST_ID.SUGGESTIONS_SKELETON}>
            <AutoCompleteSkeleton />
            <ProductCardsSkeleton />
        </SkeletonGroupsWrapper>
    );
};
